import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import './Detail.css'
import Modal from 'react-responsive-modal';
import ModalCart from 'react-modal';
import 'react-responsive-modal/styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart, faExternalLinkAlt, faStar, faTrash, faHeart } from '@fortawesome/free-solid-svg-icons';
import whatsappIcon from '../../images/wpp.png';
import { Link as Anchor, useNavigate, useLocation } from "react-router-dom";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import baseURL from '../url';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DetailLoading from "../DetailLoading/DetailLoading";
import moneda from '../moneda';

import { DateRange } from "react-date-range";
import { addDays, addYears } from "date-fns";
import es from "date-fns/locale/es";
import CarouselDetail from "./CarouselDetail";

export default function Detail() {
    const navigate = useNavigate();
    const { idProducto } = useParams();
    const [categoriaEsAcomodacion, setCategoriaEsAcomodacion] = useState(false);

    // noches y totales calculados
    const [noches, setNoches] = useState(0);
    const [nochesTotal, setNochesTotal] = useState(0); // total monetario
    const [detallePrecios, setDetallePrecios] = useState([]); // array {fecha, precio, alta}

    const [fechasNoDisponibles, setFechasNoDisponibles] = useState([]);

    const [producto, setProducto] = useState(null);
    const [reglas, setReglas] = useState([]); // importante iniciar como array
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImage, setModalImage] = useState("");
    const [cantidad, setCantidad] = useState(1);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [contactos, setContactos] = useState([]);
    const [favoritos, setFavoritos] = useState([]);
    const items = [producto?.item1, producto?.item2, producto?.item3, producto?.item4, producto?.item5, producto?.item6, producto?.item7, producto?.item8, producto?.item9, producto?.item10]
    const precios = [producto?.precio1, producto?.precio2, producto?.precio3, producto?.precio4, producto?.precio5, producto?.precio6, producto?.precio7, producto?.precio8, producto?.precio9, producto?.precio10]
    const [categorias, setCategorias] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const location = useLocation();
    const [estadoAbierto, setEstadoAbierto] = useState(true);
    const [horarioHoy, setHorarioHoy] = useState(null);

    const [range, setRange] = useState([
      {
        startDate: new Date(),
        endDate: addDays(new Date(), 1),
        key: "selection",
      },
    ]);

    /* ---------- CARGAS INICIALES ---------- */
    useEffect(() => {
        cargarProductos();
        cargarContacto();
        cargarFavoritos();
        cargarCategoria();
        verificarEstado();
    }, []);

    const verificarEstado = () => {
        fetch(`${baseURL}/horariosCheck.php`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    setEstadoAbierto(data.abierto);
                    setHorarioHoy(data.horario);
                }
            })
            .catch(() => setEstadoAbierto(true));
    };

    const handleSelectionChange = (index) => {
        if (selectedItems.includes(index)) {
            setSelectedItems(selectedItems.filter(i => i !== index));
        } else {
            setSelectedItems([...selectedItems, index]);
        }
    };
    const cargarCategoria = () => {
        fetch(`${baseURL}/categoriasGet.php`, { method: 'GET' })
            .then(response => response.json())
            .then(data => setCategorias(data.categorias || []))
            .catch(() => {});
    };
    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, { method: 'GET' })
            .then(response => response.json())
            .then(data => setContactos(data.contacto.reverse()[0] || []))
            .catch(() => {});
    };
    
    const cargarFechasNoDisponibles = () => {
        fetch(`${baseURL}/getProductoReservas.php?idProducto=${idProducto}`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                setFechasNoDisponibles(data.rangos.map(r => ({
                    start: new Date(r.start.y, r.start.m, r.start.d),
                    end:   new Date(r.end.y,   r.end.m,   r.end.d)
                })));
            })
            .catch(() => setLoading(true));
    };

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos || []);
                setLoading(false);
            })
            .catch(() => setLoading(true));
    };

    const cargarFavoritos = () => {
        const storedFavoritos = JSON.parse(localStorage.getItem('favoritos')) || [];
        setFavoritos(storedFavoritos);
    };

    /* ---------- CUANDO CAMBIAN productos / idProducto ---------- */
    useEffect(() => {
        const product = productos.find((e) => e.idProducto === parseInt(idProducto));
        if (!product) {
            setProducto(null);
            setReglas([]);
            return;
        }
        cargarFechasNoDisponibles();
        // determinar categoría acomodacion
        let categoriaProducto = categorias.filter(categoriaFiltrada => categoriaFiltrada.idCategoria === product.idCategoria);
        if(categoriaProducto && categoriaProducto[0] && categoriaProducto[0].categoria){
            const textoNormalizado = (str) => str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            let isAcomodationValue = textoNormalizado(categoriaProducto[0].categoria.toLowerCase())
                .includes(textoNormalizado("acomodacion".toLowerCase()));
            setCategoriaEsAcomodacion(isAcomodationValue);
        } else {
            setCategoriaEsAcomodacion(false);
        }

        setProducto(product);

        // reglas: puede venir como string JSON o ya como array
        let r = [];
        try {
            if (product.rules_prices) {
                r = typeof product.rules_prices === 'string' ? JSON.parse(product.rules_prices) : product.rules_prices;
                if (!Array.isArray(r)) r = [];
            }
        } catch (e) {
            console.warn("rules_prices parse error:", e);
            r = [];
        }
        setReglas(r);

    }, [idProducto, productos, categorias]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const fechaOcupada = (date) => {
      return fechasNoDisponibles.some((range) => {
        return date >= range.start && date < addDays(range.end, 1); // comparar inclusive
      });
    };

    /* ---------- Temporada alta check ---------- */
    const esTemporadaAlta = (date) => {
      if (!reglas || reglas.length === 0) return false;

      const diasSemana = [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado",
      ];

      const nombreDia = diasSemana[date.getDay()]; // 0 = domingo
      const fechaFormato = date.toISOString().split("T")[0]; // YYYY-MM-DD

      return reglas.some((r) => {
        if (!r || !r.type || !r.value) return false;
        if (r.type === "weekday") {
          return r.value.toLowerCase() === nombreDia;
        }
        if (r.type === "date") {
          return r.value === fechaFormato;
        }
        return false;
      });
    };

    /* ---------- Recalcular noches / detalle / total cuando cambia range, producto o reglas ---------- */
    useEffect(() => {
        if (!producto || !range || !range[0]) {
            setNoches(0);
            setNochesTotal(0);
            setDetallePrecios([]);
            return;
        }

        const start = new Date(range[0].startDate);
        const end = new Date(range[0].endDate);
        // noches: diferencia en días (endDate - startDate)
        const msPorDia = 1000 * 60 * 60 * 24;
        const nochesCalc = Math.max(0, Math.round((end - start) / msPorDia));

        // recorrer cada noche (noche = fechaActual desde start hasta end - 1)
        const detalle = [];
        let total = 0;
        const precioNormal = Number(producto.precio || 0);
        const precioTa = Number(producto.precio_ta || producto.precio || 0); // fallback a precio si no viene precio_ta

        let fechaActual = new Date(start);
        for (let i = 0; i < nochesCalc; i++) {
            const alta = esTemporadaAlta(fechaActual);
            const precioNoche = alta ? precioTa : precioNormal;
            detalle.push({
                fecha: fechaActual.toISOString().split('T')[0],
                precio: precioNoche,
                alta,
            });
            total += precioNoche;
            fechaActual = addDays(fechaActual, 1);
        }

        setNoches(nochesCalc);
        setDetallePrecios(detalle);
        setNochesTotal(total);

    }, [range, producto, reglas]);

    /* ---------- Acciones UI ---------- */
    function handleCompartirClick() {
        if (navigator.share) {
            navigator.share({
                title: document.title,
                text: 'Echa un vistazo a este producto',
                url: window.location.href,
            }).catch(() => {});
        }
    }

    const handleWhatsappMessage = () => {
        if (!estadoAbierto) {
            toast.error('El alojamiento está cerrado.', { autoClose: 3000 });
            return;
        }
        // ... mantuve tu lógica (omito redundancia para brevedad)
        const phoneNumber = contactos?.telefono;
        const title = producto?.titulo;
        let precioTotal = Number(producto?.precio || 0);
        const selectedItemsText = selectedItems.map(index => {
            const itemName = items[index];
            const itemPrice = precios[index] || 0;
            precioTotal += Number(itemPrice);
            return itemPrice > 0 ? `${itemName} (+${moneda} ${itemPrice})` : itemName;
        }).join(', ');

        const formattedPrice = precioTotal.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        const message = `Hola 🌟, quisiera más información sobre\n\n✅ *${title}*\n     Adicionales: ${selectedItemsText}\n     Total: ${moneda} ${formattedPrice}`;
        window.open(`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`, '_blank');
    };

    const goBack = () => {
        if (location.key !== 'default') navigate(-1);
        else navigate('/');
    };

    const addToCart = () => {
        if (!producto) return;
        if (!estadoAbierto && !categoriaEsAcomodacion) {
            toast.error('El alojamiento está cerrado.', { autoClose: 3000 });
            return;
        }

        const cart = JSON.parse(localStorage.getItem('cart')) || [];
        const selectedItemsData = selectedItems?.map(index => ({ name: items[index], price: precios[index] || 0 }));

        if (categoriaEsAcomodacion) {
            cart.push({
                idProducto: producto.idProducto,
                items: selectedItemsData,
                cantidad,
                fecha_inicio: range[0].startDate.toISOString().split("T")[0],
                fecha_fin: range[0].endDate.toISOString().split("T")[0],
                noches,
                total: nochesTotal,
                detalle: detallePrecios,
            });
            toast.success("Alojamiento agregado al carrito", { autoClose: 1000 });
        } else {
            cart.push({ idProducto: producto.idProducto, items: selectedItemsData, cantidad });
            toast.success('Producto agregado', { autoClose: 1000 });
        }

        localStorage.setItem('cart', JSON.stringify(cart));
        cargarProductos();
        setTimeout(() => window.location.reload(), 600);
    };

    const incrementCantidad = () => setCantidad(cantidad + 1);
    const decrementCantidad = () => cantidad > 1 && setCantidad(cantidad - 1);

    const agregarAFavoritos = (idProducto) => {
        const favList = [...favoritos];
        const index = favList.indexOf(idProducto);
        if (index === -1) {
            favList.push(idProducto);
        } else {
            favList.splice(index, 1);
        }
        setFavoritos(favList);
        localStorage.setItem('favoritos', JSON.stringify(favList));
    };

    const formatFecha = (ymd) => {
        const [year, month, day] = ymd.split("-");
        return `${day}/${month}/${year}`;
    };

    const formatearPrecioCorto = (num) => {
        if (num >= 1_000_000)
            return (num / 1_000_000).toFixed(1).replace('.0', '') + "M";

        if (num >= 1_000)
            return Math.round(num / 1_000) + "K";

        return num;
    };

    if (!producto) return <DetailLoading />;

    return (
        <div className="detail">
            <ToastContainer />
            <div className="deFlexDetail">
                <button className="back" onClick={goBack}><FontAwesomeIcon icon={faArrowLeft} /></button>
                <div className="deFLexIcon">
                    <button onClick={() => agregarAFavoritos(producto.idProducto)} className='favoritos-btn'>
                        <FontAwesomeIcon icon={faHeart} style={{ color: favoritos.includes(producto.idProducto) ? 'red' : 'gray' }} />
                    </button>
                    <button className="share" onClick={handleCompartirClick}><FontAwesomeIcon icon={faExternalLinkAlt} /></button>
                </div>
            </div>

            <div className="detail-contain">
                <CarouselDetail
                    producto={producto}
                    setModalImage={setModalImage}
                    setIsModalOpen={setIsModalOpen}
                />
                <div className="textDetail">
                    <h2 className="title">{producto.titulo}</h2>
                    <hr />
                    <div className="deFLexBuet">
                        {categorias.filter(c => c.idCategoria === producto.idCategoria).map(c => (
                            <h4 key={c.idCategoria}><FontAwesomeIcon icon={faStar} /> {c.categoria}</h4>
                        ))}
                    </div>

                    {!categoriaEsAcomodacion && (
                        <div className='deFLexPrice'>
                            <h5 className="price">{moneda} {String(producto?.precio)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                            { (producto?.precioAnterior !== 0 && producto?.precioAnterior !== undefined) && (
                                <h5 className='precioTachadoDetail'>{moneda} {String(producto?.precioAnterior).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                            )}
                        </div>
                    )}

                    <p className="descripcion">{producto.descripcion}</p>

                    <div className='itemsDetail'>
                        {producto && items.length > 0 && items.map((item, index) => (
                            item && (
                                <label key={index}>
                                    <input type="checkbox" checked={selectedItems.includes(index)} onChange={() => handleSelectionChange(index)} />
                                    {item} {precios[index] > 0 && ` (+${moneda} ${String(precios[index]).replace(/\B(?=(\d{3})+(?!\d))/g, ".")})`}
                                </label>
                            )
                        ))}
                    </div>

                    {producto.disponible === "Si" ? (
                        <>
                            {categoriaEsAcomodacion && (<p className="text-acomodacion">Seleccione sus fechas</p>)}

                            {!categoriaEsAcomodacion && (
                                <div className='deFlexCart'>
                                    <button onClick={decrementCantidad}>-</button>
                                    <span>{cantidad}</span>
                                    <button onClick={incrementCantidad}>+</button>
                                </div>
                            )}

                            {categoriaEsAcomodacion && (
                                <>
                                    <DateRange
                                        ranges={range}
                                        onChange={(item) => {
                                            // evitar elegir fechas ocupadas
                                            if (fechaOcupada(item.selection.startDate) || fechaOcupada(item.selection.endDate)) {
                                                toast.error("Una o más fechas seleccionadas no están disponibles.");
                                                return;
                                            }
                                            setRange([item.selection]);
                                        }}
                                        minDate={new Date()}
                                        maxDate={addYears(new Date(), 1)}
                                        locale={es}
                                        months={2}
                                        direction={(window.innerWidth <= 768)? "vertical":"horizontal"}
                                        rangeColors={["#da4a1c"]}
                                        showDateDisplay={false}
                                        dayContentRenderer={(date) => {
                                            const ocupado = fechaOcupada(date);
                                            const temporadaAlta = esTemporadaAlta(date);
                                            const precioMostrar = temporadaAlta ? Number(producto.precio_ta || producto.precio) : Number(producto.precio || 0);
                                            return (
                                                <div style={{
                                                    height: "100%",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    background: ocupado ? "#ffb3b3" : "transparent",
                                                    borderRadius: "5px",
                                                    width: "100%",
                                                    fontWeight: ocupado ? "bold" : "normal",
                                                    color: ocupado ? "#a10000" : "#000000",
                                                    paddingTop: "4px",
                                                }}>
                                                    {date.getDate(precioMostrar)}
                                                    <p data-short={precioMostrar.toLocaleString("es-AR")} className={`price-day-calendar ${ocupado? 'es-ocupado':''}`}>${precioMostrar.toLocaleString("es-AR")}</p>
                                                </div>
                                            );
                                        }}
                                    />

                                    {/* resumen de reserva */}
                                    <div className="resumen-reserva">
                                      <h4 className="titulo-reserva">Resumen de tu reserva</h4>

                                      <div className="reserva-datos">
                                        <div className="dato">
                                          <span className="label">Fecha de entrada</span>{ " " }
                                          <strong className="valor">{new Date(range[0].startDate).toLocaleDateString()}</strong>
                                        </div>

                                        <div className="dato">
                                          <span className="label">Fecha de salida</span>{ " " }
                                          <strong className="valor">{new Date(range[0].endDate).toLocaleDateString()}</strong>
                                        </div>

                                        <div className="dato">
                                          <span className="label">Noches</span>{ " " }
                                          <strong className="valor">{noches}</strong>
                                        </div>

                                        <div className="dato total">
                                          <span className="label">Total</span>{ " " }
                                          <strong className="valor">
                                            {moneda} {nochesTotal.toLocaleString("es-AR")}
                                          </strong>
                                        </div>
                                      </div>

                                      <h5 className="subtitulo">Detalle por noche</h5>

                                      <div className="detalle-noches">
                                        {detallePrecios.map((d, i) => (
                                          <div key={i} className="item-noche">
                                            <span className="fecha-noche">{formatFecha(d.fecha)}</span>

                                            <div className="precio-noche">
                                              <strong>$ {d.precio.toLocaleString("es-AR")}</strong>

                                              {d.alta && (
                                                <span className="badge-alta">Temporada alta</span>
                                              )}
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    </div>

                                </>
                            )}

                            <div className='deFlexGoTocart f-full'>
                                <button onClick={addToCart} className='btnAdd'>
                                    Agregar <FontAwesomeIcon icon={faShoppingCart} />
                                </button>
                            </div>
                        </>
                    ) : (
                        <button className="btnDisabled" disabled>Momentáneamete la acomodación no está disponible</button>
                    )}
                </div>
            </div>

            <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)} center classNames={{ modal: 'custom-modal' }}>
                <img src={modalImage} alt={producto.titulo} />
            </Modal>
        </div>
    );
}
